export const getCount = (invoice) => {
  let count = 6;

  if (invoice?.paymentStatus === "REJECTED") {
    return invoice?.billedTo?.type === "BUSINESS" ? 5 : 3;
  }

  if (invoice?.type === "INVOICE" && invoice?.billedTo?.type === "BUSINESS") {
    count = 6;
  }
  if (invoice?.type === "INVOICE" && invoice?.billedTo?.type !== "BUSINESS") {
    count = 4;
  }
  if (invoice?.type !== "INVOICE" && invoice?.billedTo?.type === "BUSINESS") {
    count = 3;
  }
  if (invoice?.type !== "INVOICE" && invoice?.billedTo?.type !== "BUSINESS") {
    count = 1;
  }
  return count;
};

export const successCheck = (invoice) => {
  const businessInvoiceActions = [
    "SIGN_EXT_FIRS_INVOICE",
    "GENERATE_EXT_FIRS_INVOICE_QR_CODE",
    "UPDATE_EXT_FIRS_INVOICE_PAYMENT_STATUS",
    "REPORT_EXT_FIRS_INVOICE_PAYMENT",
  ];

  const nonInvoiceBusinessActions = ["SIGN_EXT_FIRS_INVOICE", "TRANSMIT_EXT_FIRS_INVOICE", "TRANSMIT_EXT_FIRS_INVOICE_COMPLETED"];

  const isRejected = invoice?.paymentStatus === "REJECTED";
  const isBusiness = invoice?.billedTo?.type === "BUSINESS";
  const isInvoice = invoice?.type === "INVOICE";

  const actualSuccess =
    invoice?.integration?.firs?.actions
      ?.filter((item) => {
        if (isRejected && isBusiness) {
          return item?.name !== "REPORT_EXT_FIRS_INVOICE_PAYMENT";
        }
        if (isRejected && !isBusiness) {
          return businessInvoiceActions.includes(item?.name) && item?.name !== "REPORT_EXT_FIRS_INVOICE_PAYMENT";
        }
        if (isInvoice && isBusiness) {
          return true;
        }
        if (isInvoice && !isBusiness) {
          return businessInvoiceActions.includes(item?.name);
        }
        if (!isInvoice && isBusiness) {
          return nonInvoiceBusinessActions.includes(item?.name);
        }
        return item?.name === "SIGN_EXT_FIRS_INVOICE";
      })
      ?.filter((item) => item?.status === "SUCCESS")?.length ?? 0;

  let expectedCount;

  if (isRejected && isBusiness) {
    expectedCount = 5;
  } else if (isRejected && !isBusiness) {
    expectedCount = 3;
  } else if (isInvoice && isBusiness) {
    expectedCount = 6;
  } else if (isInvoice && !isBusiness) {
    expectedCount = 4;
  } else if (!isInvoice && isBusiness) {
    expectedCount = 3;
  } else {
    expectedCount = 1;
  }

  const successCount = Math.min(actualSuccess, expectedCount);
  const remaining = Math.max(expectedCount - actualSuccess, 0);

  return {
    successCount,
    expectedCount,
    summary: `${successCount} / ${expectedCount}`,
    isComplete: actualSuccess >= expectedCount,
    remaining,
  };
};

export async function refetchAtInterval(query, interval = 3000, times = 5) {
  for (let i = 0; i < times; i++) {
    await query.refetch();
    if (i < times - 1) {
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }
}

export const TRANSMISSION_MODE_LABELS = {
  FILE_TRANSMISSION: "File Transmission",
  API_TRANSMISSION: "API Transmission",
};

export const formatTransmissionMode = (value) => (value ? TRANSMISSION_MODE_LABELS[value] ?? value : null);

export const ONBOARDING_CHANNEL_LABELS = {
  PORTAL: "Transmission Portal",
  API: "API",
};

export const formatOnboardingChannel = (value) => ONBOARDING_CHANNEL_LABELS[value] ?? ONBOARDING_CHANNEL_LABELS.PORTAL;
